export default __webpack_public_path__ + "4ba30a4c9335f3488badb301e1728199.png";